module.exports = __webpack_public_path__ + "static/media/ploni-demibold-aaa.8c535a82.eot";